<script setup>
import { queryAllUser, transferNewOrder } from '@/api/workPlace/transfer'
import { defineProps, defineEmits, reactive, watch, ref, createVNode } from 'vue'
import { useStore } from 'vuex'
import { haveProcessingOrder } from '@/api/workPlace/workOrder'
import { shiftStatusMap } from '@/utils/globalMap'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { initWorkOrder } from '../../hooks/workOrder'
import { REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'

const store = useStore()
const prop = defineProps({
  // 是否可见
  visible: {
    type: Boolean,
    default: false,
    required: true
  },
  groupId: {
    type: String,
    required: false
  },
  assistantPatientGroupId: {
    type: String,
    required: false
  },
  doctorDaGroupId: {
    type: String,
    required: ''
  },
  transferInfo: {
    type: Object,
    default: () => {}
  }
})
const rules = {
  transferAllotUcUserId: [
    { required: true, message: '请选择转交对象', type: 'number', trigger: 'blur' }
  ]
}

const formRef = ref()
const emit = defineEmits(['update:visible', 'onCancel'])

const confirmLoading = ref(false)
// 取消
const onCancel = () => {
  formRef.value.resetFields()
  REFRESH_LIST?.emit()
  emit('update:visible', false)
  confirmLoading.value = false
}
async function updataWorkorderList() {
  try {
    //  判断没有入参的情况
    const params = {
      ucPatientId: prop.transferInfo.ucPatientId,
      ucDoctorId: prop.transferInfo.ucDoctorId
    }
    const res = await haveProcessingOrder(params)
    if (!res) {
      const groupIds = [prop.groupId, prop.assistantPatientGroupId, prop.doctorDaGroupId]
      store.dispatch('clearAllMsg', groupIds)
      initWorkOrder()
    }
  } catch {
    //
  }
  onCancel()
}
// 发起转交请求 转交状态 0:成功 1:存在处理中工单失效
function transferAPI() {
  confirmLoading.value = true
  const params = {
    ...data,
    workOrderId: prop.transferInfo.transferId
  }
  transferNewOrder(params).then(res => {
    const tipMessage = res?.tipMessage || ''
    updataWorkorderList()
    store.dispatch('rollBack/getAllRefreshTimer')
    if (tipMessage) {
      Modal.confirm({
        title: '工单未处理提示',
        icon: createVNode(ExclamationCircleOutlined),
        content: tipMessage,
        okText: '知道了',
        centered: true
      })
    }
  })
}

// 确定提交
function onOk() {
  formRef.value.validate().then(() => {
    transferAPI()
  })
}
// 展示数据
const data = reactive({
  transferAllotUcUserId: null,
  transferRemark: ''
})
// 下拉选
const options = ref([])
const loading = ref(false)
// 远程查询
function getAllUser() {
  loading.value = true
  queryAllUser()
    .then(res => {
      options.value = res.map(v => ({
        status: v.shiftStatus,
        key: v.id,
        value: v.ucUserId,
        label: v.realName,
        related: v.relationWorkOrderHaveFlag
      }))
    })
    .finally(() => (loading.value = false))
}
const filterOption = (input, option) => {
  return option.label.indexOf(input) >= 0
}
watch(
  () => prop.visible,
  visible => {
    if (!visible) return
    getAllUser()
  },
  {
    immediate: true
  }
)
</script>
<template>
  <a-modal
    @cancel="onCancel"
    @ok="onOk"
    :maskClosable="false"
    :visible="visible"
    title="转交工单"
    :width="400"
    centered
    :confirmLoading="confirmLoading"
  >
    <a-form hide-required-mark ref="formRef" :model="data" :rules="rules" layout="vertical">
      <a-form-item label="转交对象" name="transferAllotUcUserId">
        <a-select
          v-model:value="data.transferAllotUcUserId"
          show-search
          placeholder="请选择转交对象"
          :default-active-first-option="false"
          :options="options"
          :filter-option="filterOption"
        >
          <!-- 有数据内容 -->
          <template #option="{ label, status, related }">
            <div class="option">
              <span>
                {{ label }}
                <span class="order-flag answer" v-if="related">有关联工单</span>
              </span>
              <span>
                <a-badge
                  :status="shiftStatusMap[status].status"
                  :text="shiftStatusMap[status].label"
                />
              </span>
            </div>
          </template>
          <!-- 无数据内容 -->
          <template class="not-found-content" v-if="loading" #notFoundContent>
            <a-spin size="small" />
          </template>
        </a-select>
      </a-form-item>
      <a-form-item label="转交备注" name="transferRemark">
        <a-textarea
          v-model:value="data.transferRemark"
          placeholder="请输入转交备注"
          allow-clear
          showCount
          :maxlength="100"
          :autoSize="{ minRows: 5, maxRows: 5 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<style scoped lang="scss">
.option {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  .order-flag {
    padding: 1px 4px;
    border-radius: 2px;
    font-weight: 400;
    font-size: 10px;
    margin-left: 8px;
    &.answer {
      border: 1px solid #52c41a;
      color: #52c41a;
    }
  }
}
</style>
